export const SET_QUEUE_UI_FLAG = 'SET_QUEUE_UI_FLAG';
export const CLEAR_QUEUES = 'CLEAR_QUEUES';
export const SET_QUEUES = 'SET_QUEUES';
export const SET_QUEUE_ITEM = 'SET_QUEUE_ITEM';
export const EDIT_QUEUE = 'EDIT_QUEUE';
export const DELETE_QUEUE = 'DELETE_QUEUE';
